import { Onfido as EntrustSdk } from 'onfido-sdk-ui'
import { Handle } from 'onfido-sdk-ui/types/Onfido'
import { useEffect, useState, useRef } from 'react'
import { logInfoToDatadog, logErrorToDatadog } from '../../../common/utils'
import { Container, EntrustMount, Item, Link, List, GlobalEntrustStyles } from './styles'

interface EntrustProps {
  sdkToken?: string
  workflowRunId?: string
}

const Entrust = ({ sdkToken, workflowRunId }: EntrustProps) => {
  const [loading, setLoading] = useState(false)
  const entrustInstanceRef = useRef<Handle | null>(null)

  const initEntrust = () => {
    setLoading(true)

    try {
      const instance = EntrustSdk.init({
        token: sdkToken,
        containerId: 'entrust-mount',
        workflowRunId,
        theme: {
          name: 'light',
        },
        enterpriseFeatures: {
          logoCobrand: {
            darkLogoSrc: 'https://bot.references.goodlord.co/assets/img/gl_logo.svg',
            lightLogoSrc: 'https://bot.references.goodlord.co/assets/img/gl_logo.svg',
          },
        },
        language: 'en_GB',
        translations: {
          en_GB: {
            welcome: {
              title:
                'We need to verify your identity as part of your rental application.',
              subtitle: `This should only take a couple of minutes. You'll scan a photo ID (passport, driving licence, or national ID card) and take a selfie to confirm it's really you.`,
              button: {
                default: 'Start verification',
              },
            },
            complete: {
              outro: {
                title: "Thanks! That's all we need to verify your identity.",
                body: 'Now, close this tab and return to your referencing conversation to complete your application.',
              },
            },
            error: {
              expired_token: {
                title: 'Session expired',
                subtitle:
                  'For your security, this verification session timed out. Please return to the previous screen and start again.',
              },
            },
          },
        },
      })
      entrustInstanceRef.current = instance

      logInfoToDatadog('Entrust SDK initialized successfully', {
        event: 'ENTRUST_SDK_INIT_SUCCESS',
        workflowRunId,
      })
    } catch (error) {
      console.error('Error initializing Entrust SDK:', error)
      logErrorToDatadog(
        'Failed to initialize Entrust SDK',
        {
          event: 'ENTRUST_SDK_INIT_ERROR',
          workflowRunId,
        },
        error instanceof Error ? error : undefined,
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    initEntrust()
    return () => {
      if (
        entrustInstanceRef.current &&
        typeof entrustInstanceRef.current.tearDown === 'function'
      ) {
        entrustInstanceRef.current.tearDown()
      }
    }
  }, [sdkToken, workflowRunId])

  return (
    <>
      <GlobalEntrustStyles />
      <Container>
        <EntrustMount id="entrust-mount">{loading && <div>Loading...</div>}</EntrustMount>
        <List>
          <Item>
            <Link href="https://onfido.com/privacy" target="_blank">
              Onfido Privacy Policy
            </Link>
          </Item>
        </List>
      </Container>
    </>
  )
}

export default Entrust
